export const NEXT_STEP = "signup/NEXT_STEP";
export const PREV_STEP = "signup/PREV_STEP";
export const SET_SIGNUP_CONTACT = "signup/SET_SIGNUP_CONTACT";
